import classNames from 'classnames';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { Drawer } from 'palette/Drawer';
import { ModalContext, ModalBoxHeader, ModalBoxBody } from 'palette/Modal';
import { filterSelectors } from '@common/Filters/selectors';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { persistFilters } from '@common/Listing/helpers/listingLinks';
import { SUB_CAT_HORIZONTAL_MODAL_ID } from '@common/SubCategories/constants';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import SubCatModal from './SubCatModal';
import '../styles/SubCatHorizontal.scss';

function SubCatHorizontal({
    customClass,
    subcategories,
    theme
}) {
    const { setActiveModalId } = useContext(ModalContext);
    const activeFilters = useSelector(filterSelectors.activeFilters);
    const translate = useTranslation();
    const config = useConfig();

    const handleOpenCategories = () => {
        setActiveModalId(SUB_CAT_HORIZONTAL_MODAL_ID);
    };

    return (
        <div className={classNames('subcat-horizontal', customClass, { [`subcat-horizontal--theme-${theme}`]: theme })}>
            <Drawer
                anchor="right"
                id={SUB_CAT_HORIZONTAL_MODAL_ID}
            >
                <ModalBoxHeader title={translate('listing.subcategories.select')} />
                <ModalBoxBody>
                    <SubCatModal subcategories={subcategories} />
                </ModalBoxBody>
            </Drawer>
            <Button
                className="subcat-horizontal__link"
                iconName="palette_grid"
                label={translate('listing.subcategories.cbutton')}
                size="medium"
                theme="secondary"
                onClick={handleOpenCategories}
            />
            {subcategories.children.map(subcat => (
                <Button
                    key={subcat.id}
                    className="subcat-horizontal__link"
                    href={persistFilters(subcat.href, activeFilters)}
                    label={getTranslatedPropertyFromContext(subcat, 'name', config)}
                    size="medium"
                    theme="secondary"
                />
            ))}
        </div>
    );
}

export default SubCatHorizontal;
